<template>
    <advisor-detail
        v-if="selectedAdvisor"
        :fromListPage="!advisor"
        :unSelectAdvisorClick="unSelectAdvisor"
    ></advisor-detail>

    <div :class="[newConsumerDirect.length ? 'advisor-search-page show-consumer-direct' : 'advisor-search-page']" v-if="!selectedAdvisor && !isInitializing">
      <div class="jumbotron bg-parallax herobanner-jumbotron-bg-blue advisor-search-results-hero-tabs"
        :style="{ backgroundImage: `url(${bannerImage})` }"
        :data-mobileimage="mobileBannerImage"
        :data-tabletimage="tabletBannerImage"
        :data-desktopimage="desktopBannerImage"
        v-if="!selectedAdvisor"
      >
        <div class="jumbotron-overlay bg-blue"></div>
        <div class="container herobanner-jb-container">
          <div class="row d-flex justify-content-center">
            <div class="col-sm-12">
              <h1 class="hero-headline">
                {{ pageTitle }}
              </h1>
            </div>
          </div>
          <div class="row advisor-search-page-tabs" role="tablist">
            <button
              role="tab"
              id="advisor-search-page-tab_by_location"
              aria-controls="advisor-search-by-location"
              v-bind:aria-selected="searchType == 'location' ? 'true' : 'false'"
              v-bind:class="{ 'col-xs-6 col-md-6 advisor-search-page-tabs_zip advisor-search-tabs_tab movable-arrows': true, 'active-tab': searchType == 'location'}"
              @click="toggleSearch('location')"
            >
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                class="bi bi-geo-alt"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                ></path>
              </svg>
              <span>{{ searchByAdvisorTypeTabText }}</span>
            </button>
            <button
              role="tab"
              id="advisor-search-page-tab_by_name"
              aria-controls="advisor-search-by-name"
              tabindex="-1"
              v-bind:aria-selected="searchType == 'name' ? 'true' : 'false'"
              v-bind:class="{ 'col-xs-6 col-md-6 advisor-search-page-tabs_name advisor-search-tabs_tab movable-arrows': true, 'active-tab': searchType == 'name'}"
              @click="toggleSearch('name')"
            >
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                class="bi bi-person-fill"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                ></path>
              </svg>
              <span>{{ searchByNameTypeTabText }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="container advisor-search-page-wrap" v-if="!selectedAdvisor">
        <search-location v-if="!selectedAdvisor && searchType == 'location'" :presetType="type" :tabTitle="searchByAdvisorTypeTabText"></search-location>
        <search-name v-if="searchType == 'name'" :presetType="type" :tabTitle="searchByNameTypeTabText"></search-name>
      </div>
      <advisor-list
          v-if="!selectedAdvisor && hasSearch || isDirectConsumer"
          :noResultsFoundFn="toggleSearchByLocation"
          :type="type"
          :pageSize="20"
      ></advisor-list>
    </div>
    <div v-if="disclaimers && !selectedAdvisor" class="container full-width-container bleed-bgs disclaimer-container">
        <div class="row">
            <div class="col-md-12">
                <div class="disclaimer disclaimer-ul" v-html="disclaimers"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import AdvisorList from "./components/advisorList.vue";
import AdvisorDetail from "./components/advisorDetailItem.vue";
import SearchLocation from "./components/searchByLocation.vue";
import SearchName from "./components/searchByName.vue";

export default {
  data() {
    return {
      searchType: "location"
    };
  },
  created() {
    window.updateAdvisorsWithConsumer = this.updateAdvisorsWithConsumer;
  },
  mounted() {
    if (this.advisor) {
      this.getSpecificAdvisor({
        id: this.advisor
      });
    } else {
      this.isInitializing = false;
    }
    if (typeof HERO_speedbump != "undefined") {
      setTimeout(function(){
        HERO_speedbump.init();
      }, 1000);
    }
  },
  components: {
    "advisor-detail": AdvisorDetail,
    "advisor-list": AdvisorList,
    "search-location": SearchLocation,
    "search-name": SearchName
  },
  computed: {
    hasSearch() {
      return (
        (this.userSearchLocation &&
          this.userSearchLocation.lat &&
          this.userSearchLocation.lng) ||
        this.userSearchName
      );
    },
    isDirectConsumer: {
      get() {
          return this.$store.getters.isDirectConsumer;
      }
    },
    newConsumerDirect: {
      get() {
        return this.$store.getters.newConsumerDirect;
      }
    },
    isInitializing: {
      get() {
        return this.$store.getters.isInitializing;
      },
      set(value) {
        this.updateIsInitializing(value);
      }
    },
    isMobile() {
      return this.$mq != 'desktop';
    },
    isWealthAdvisorSearch() {
      return this.type == "Wealth Advisor";
    },
    searchByAdvisorTypeTabText() {
      if (this.isMobile) {
        if (this.isWealthAdvisorSearch) {
          return "By location";
        } else {
          return "By advisor type";
        }
      }
      else {
        if (this.isWealthAdvisorSearch) {
          return "Search by location";
        } else {
          return "Search by advisor type";
        }
      }
    },
    searchByNameTypeTabText() {
      if (this.isMobile) {
        return "By name";
      }
      else {
        return "Search by name";
      }
    },
    bannerImage() {
      if (this.isMobile) {
        return this.mobileBannerImage;
      } else {
        return this.tabletBannerImage;
      }
    },
    selectedAdvisor: {
      get() {
        return this.$store.getters.selectedAdvisor;
      },
      set(value) {
        this.updateSelectedAdvisor(value);
      }
    },
    userSearchLocation: {
      get() {
        return this.$store.getters.userSearchLocation;
      }
    },
    userSearchName: {
      get() {
        return this.$store.getters.userSearchName;
      },
      set(value) {
        this.updateUserSearchName(value);
      }
    }
  },
  methods: {
    ...mapActions([
      "clearSearch",
      "getSpecificAdvisor",
      "updateIsInitializing",
      "updateSelectedAdvisor",
      "updateUserSearchName",
      "updateAdvisorsWithConsumer"
    ]),
    unSelectAdvisor() {
      this.selectedAdvisor = null;
    },
    toggleSearch(searchType) {
      this.clearSearch();
      this.searchType = searchType;
    },
    toggleSearchByLocation() {
      this.searchType = "location";
      this.userSearchName = {
        name: null
      };
    }
  },
  props: {
    advisor: String,
    desktopBannerImage: String,
    mobileBannerImage: String,
    tabletBannerImage: String,
    type: String,
    pageTitle: String,
    disclaimers: String
  }
};
</script>
